'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');
var graphicsHelper = require('../../helper/graphicsHelper');
var util = require('../../helper/util');

/**
 * 柱状图
 */
var BarChart = React.createClass({

  render: function () {

    var style = styleHelper.StyleUtil(this.props).bounds().border().style;
    var width = Math.round(style.width * 0.9);
    var height = Math.round(style.height * 0.9);
    var lineWidth = 1;
    var offset = style.height - height;

    var result = graphicsHelper.parseText(styleHelper.getText(this.props));
    var data_arr = result["areas"].reverse();
    var color_arr = result["colors"].reverse();

    var isShowBorder = (style.borderWidth != "inherit");

    var itemHeight = (height)/data_arr.length;
    var className = "";
    if(isShowBorder) {
      className = "chart-item";
    }
    return (
      <div className="component-SimpleCom component-BarChart">
        {
          data_arr.map(function(item,index){
            return (
              <div
                key={index}
                className={className} style={{
                width:Math.round(item / 100 * width * 0.9),
                height:Math.round(itemHeight * 0.75),
                top:height - Math.round(itemHeight*index + itemHeight) + offset,
                left:0,
                backgroundColor:color_arr[index],
                position: 'absolute'
            }}></div>)
          },this)
        }
        <div className="component-Chart-Coord"></div>

      </div>
    )
  }

});

module.exports = BarChart;



// WEBPACK FOOTER //
// ./src/views/Components/BarChartEx.jsx